import { useMutation } from '@tanstack/react-query'
import { updateExtractedData } from '@wove/api'

export const useUpdateDocument = (shipmentId: string, documentId: string) => {
  return useMutation({
    mutationFn: ({ data, changes }: { data: any; changes: any }) =>
      updateExtractedData(shipmentId, documentId, data, changes),
  })
}
